export default __webpack_public_path__ + "app/styles/fonts/lato/lato-v11-latin-900.svg";